import React, {useRef} from 'react';
import Input from '../../../../component/input/Input';
import {Formik, Form} from 'formik';
import * as Yup from 'yup';
import * as css from './CommitteePopup.css';
import BottomPopup from '../bottomPopup/BottomPopup';
import {updateClubPermission} from '../../../../redux/account/accountActions';
import {useTranslation} from 'react-i18next';
import {STATIC_IMAGE} from '../../../../config/config';
import CheckboxFormik from '../../../../component/checkboxFormik/CheckboxFormik';
import {DEFAULT_COLOR} from '../../../../globalVariables/GlobalVariables';
import useTimeout from '../../../../hooks/useTimeout';

interface Permission {
    title?: string;
    clubName: string;
    token?: string;
    autoActivate?: boolean;
    clubId?: string;
    status?: number;
}

interface PopupShow {
    isOpen: boolean;
    close: () => void;
    open: () => void;
    showClass?: string;
}

interface CommitteePopupProps {
    permission: Permission;
    popupShow: PopupShow;
}

function CommitteePopup({permission, popupShow}: CommitteePopupProps) {
    const formRef = useRef<any>(null);
    const timer = useTimeout();
    const {t} = useTranslation('permission');
    const layoutT = useTranslation('layout').t;
    const packageT = useTranslation('package').t;

    const initialValues = {
        title: permission.title || t(permission.clubName),
        token: permission.token || '',
        autoActivate: Boolean(permission.autoActivate) || false,
    };

    const validationSchema = Yup.object().shape({
        title: Yup.string().required(),
        token: Yup.string().required(),
        autoActivate: Yup.boolean().required(),
    });
    
    const onSubmitForm = async (values: typeof initialValues) => {
        await updateClubPermission({...values, clubName: permission.clubName, clubId: permission.clubId, status: 1});
        timer.current = setTimeout(() => {
            popupShow.close();
        }, 2000);
    };

    const acceptClick = () => {
        if(formRef.current) {
            formRef.current.submitForm();
        }
    };
    
    return (
        <Formik
            innerRef={formRef}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmitForm}
        >
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <css.committeePopup>
                    <BottomPopup
                        icon={`${STATIC_IMAGE}/app/clubPermissionPopup.png`}
                        close={popupShow.close}
                        showClass={popupShow.showClass}
                        headerText={t(permission.clubName)}
                        acceptClick={acceptClick}
                        textCancel={layoutT('cancelBtn')}
                        textAccept={packageT('goForIt')}
                    >
                        <css.popupContent>
                            <css.title>{t(`${permission.clubName}Title`)}</css.title>
                            <css.subTitle>
                                {t(`${permission.clubName}Instructions`)}
                            </css.subTitle>
                            <css.fields>
                                <css.inputWrapper>
                                    <Input 
                                        name="title" 
                                        text={t(`${permission.clubName}Name`)}
                                        icon={false}
                                        events={{}}
                                        className=""
                                        forwardRef={null}
                                    />
                                </css.inputWrapper>
                                <css.inputWrapper>
                                    <Input 
                                        name="token" 
                                        text={t('numberId')}
                                        icon={false}
                                        events={{}}
                                        className=""
                                        forwardRef={null}
                                    />
                                </css.inputWrapper>
                            </css.fields>
                            <css.checkBoxWrap>
                                <CheckboxFormik name={'autoActivate'} text={t('activateAutomatically')} className={''} color={DEFAULT_COLOR} />
                            </css.checkBoxWrap>
                        </css.popupContent>
                    </BottomPopup>
                </css.committeePopup>
            </Form>
        </Formik>
    );
}

export default CommitteePopup; 